var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    _setup.isMobile
      ? _c(
          "div",
          [
            _c(_setup.TheHeader),
            _vm._v(" "),
            _setup.context.request.user.is_staff
              ? _c(
                  "div",
                  { staticClass: "d-flex justify-center mb-2" },
                  [_c(_setup.HeaderChangeFlavour)],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass:
              "header d-flex justify-space-between align-center mt-5",
          },
          [
            _c("div", { staticClass: "header-col" }, [
              _c(
                "div",
                { staticClass: "d-flex justify-start align-center" },
                [
                  _setup.context.available_languages.length
                    ? _c(_setup.HeaderLanguageToggle, { staticClass: "mr-3" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(_setup.HeaderTown),
                ],
                1
              ),
              _vm._v(" "),
              _setup.context.request.user.is_staff
                ? _c(
                    "div",
                    [_c(_setup.HeaderChangeFlavour, { staticClass: "mt-2" })],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column justify-center align-center header-col",
              },
              [
                _c(_setup.HeaderLogo),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "text-subtitle-1 text-secondary--text text-center",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _setup.filterIntcomma(_setup.context.stat.rates_total)
                        ) +
                        "\n        " +
                        _vm._s(
                          _setup.filterCase(_setup.context.stat.rates_total, [
                            _setup.t("отзыв", _setup.options),
                            _setup.t("отзыва", _setup.options),
                            _setup.t("отзывов", _setup.options),
                          ])
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex justify-end align-center header-col" },
              [
                _setup.context.request.country.is_russia
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-end align-center" },
                      [
                        _c(_setup.HeaderExpert, { staticClass: "mr-8" }),
                        _vm._v(" "),
                        _c(_setup.HeaderAnalyses, { staticClass: "mr-4" }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(_setup.HeaderAuth),
              ],
              1
            ),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }